export default [
  {
    path: "/HzF97Sr9Azk2e0kY8w7w",
    children: [
    {
        path: "yHzlk5sue4oo",
        name: "userList",
        meta: {
          title: "Admin(s)",
          authRequired: true,
          acc: ["v55", "v12"],
        },
        component: () => import("../views/users/list.vue"),
      },
      {
        path: "CJ4PT6oqXVs2/:id?",
        name: "viewUser",
        meta: {
          title: "View Admin",
          authRequired: true,
          acc: ["v55", "v12"],
          breadcrumb:{
                route: 'userList'
            
            },
        },
        component: () => import("../views/users/view.vue"),
      },
      {
        path: "RbfYOERL4zQJ",
        name: "newUser",
        meta: {
          title: "New Admin",
          authRequired: true,
          acc: ["v55"],
        },
        component: () => import("../views/users/new.vue"),
      },

      {
        path: "TTYttoRCkhRE/:id?",
        name: "updateUser",
        meta: {
          title: "Update Admin",
          authRequired: true,
          acc: ["y79424"],
        },
        component: () => import("../views/users/update.vue"),
      },
      {
        path: "32ncLKV9gDJx/:id?",
        name: "updateUserPassword",
        meta: {
          title: "Update Admin Password",
          authRequired: true,
          acc: ["y79424"],
        },
        component: () => import("../views/users/updatePassword.vue"),
      },
      {
        path: "IaO3ZMw8rPYX/:id?",
        name: "updateUserRole",
        meta: {
          title: "Update Admin Role",
          authRequired: true,
          acc: ["y79424"],
        },
        component: () => import("../views/users/updateRole.vue"),
      },
     
      
      
    ],
  },
];
